export default __webpack_public_path__ + "static/media/shape-news-feed.c971581f.svg";